export default "__VITE_ASSET__XcXMYRXd__"